import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import { withSnackbar } from 'notistack';
import React, { useState } from 'react';
import { ACCOUNT_UPDATE } from '../../../helpers/graphql/broadcast';
import graphQLClient from '../../../helpers/graphQLClient';

const UpdateProfileButton = props => {
  const { variables, isError } = props;

  const [changing, setChanging] = useState(false);

  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      const { enqueueSnackbar } = props;
      enqueueSnackbar(notification.message, { variant });
    }
  };

  const broadcast = () => {
    if (isError) {
      newNotification({
        success: false,
        message:
          'Some social media settings are incorrect (they are underlined in red). Please fix them before saving.',
      });
    } else {
      setChanging(true);
      graphQLClient(ACCOUNT_UPDATE, variables)
        .then(res => {
          if (res && res.accountUpdate) newNotification(res.accountUpdate);
          setChanging(false);
          props.afterUpdate();
        })
        .catch(err => {
          newNotification({
            success: false,
            message:
              err.message === 'Failed to fetch'
                ? 'Network Error. Are you online?'
                : `Profile update failed: ${err.message}`,
          });
          setChanging(false);
        });
    }
  };

  return (
    <Button
      fullWidth
      color="primary"
      variant="contained"
      onClick={broadcast}
      disabled={changing}
    >
      <SaveIcon />
      <span className="pl-2">Update Profile </span>
      {changing && <CircularProgress className="ml-2" size={24} />}
    </Button>
  );
};

export default withSnackbar(UpdateProfileButton);
